import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CommunityServedService {

  _communityServed: string;

  set communityServed(value: string) {
    this._communityServed = value;
  }

  get communityServed(): string {
    return this._communityServed;
  }

  constructor() { }
}
